module.exports = __webpack_public_path__ + "img/CRIT_AIR_4.32fc7a4b.png";